/*
ContentView.js
中间的内容
 */

import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Bubble, Prompts } from '@ant-design/x';
import { Row, Col, Button, Space, message } from 'antd';
import {
    CopyFilled,
    CoffeeOutlined,
    SmileOutlined,
    FireOutlined,
    UserOutlined,
    LikeFilled,
    DislikeFilled,
    SoundFilled,
} from "@ant-design/icons";

import { roles } from "../../Common/Roles/Roles";
import {
    ACTIVE_SESSION_DEFAULT_VALUE,
    ACTIVE_SESSION_KEY,
    SUGGESTION_DEFAULT_VALUE_1,
    SUGGESTION_DEFAULT_VALUE_2,
    SUGGESTION_DEFAULT_VALUE_3
} from "../../Common/constants";
import { addSessionMessages, updateSessionSuggestions } from "../../Model/IndexedDB";
import copyChatMessages from "./functions/copyChatMessages";
import BullShitFeedBackModal from "./View/BullShitFeedBackModal";
import submitExcellentResponse from "./functions/submitExcellentResponse";
import VoiceModal from "./View/VoiceModal/VoiceModal";
import { generateVoice } from './View/VoiceModal/generateVoice';
import getQuestions from '../../NetComponents/getQuestions';


const ContentView = ({ messages = [], questions = [], onRequest, willScroll, setWillScroll, isMobile, setSuggestions }) => {
    // Hooks调用message
    const [messageApi, contextHolder] = message.useMessage();
    // 对话
    const [messageItems, setMessageItems] = useState([]);
    // 拓展问题prompts
    const [prompts, setPrompts] = useState([]);
    // 反馈状态，0：无反馈，1：赞，2：BullShit
    const [feedBackCode, setFeedBackCode] = useState(0);
    // BullShit反馈Modal开启
    const [bullShitModalOpen, setBullShitModalOpen] = useState(false);
    // 创建一个 ref 用于引用容器
    const containerRef = useRef(null);
    // 使用 useRef 来记录上一次的 messages
    const prevMessagesRef = useRef([]);
    // 语音播报Modal
    const [voiceModalOpen, setVoiceModalOpen] = useState(false);
    // 是否拿到了语音文件
    const [isGotVoice, setIsGotVoice] = useState(false);
    // 音频audio
    const voiceAudio = useRef(null);
    // 当前语音的请求编号，防止因为是异步获取音频操作，导致的在中途关闭modal，而下次同时播放两个声音的现象
    const voiceRequestId = useRef(0);

    // 更新对话
    useEffect(() => {
        // 如果 messages 发生变化
        if (prevMessagesRef.current !== messages) {
            setFeedBackCode(0);  // 重置 feedBackCode
        }
        prevMessagesRef.current = messages;  // 更新 prevMessagesRef 为当前 messages

        const items = messages.map(({ id, status, message }, index) => ({
            key: id,
            role: status === 'local' ? 'user' : 'point5',
            content: message,
            footer: (messages.length > 1 && index === messages.length - 1 && status !== 'local') ? (
                <Space size='large'>
                    {/*<Button size="large" type="text" icon={<SyncOutlined/>}/>*/}
                    {/*拷贝按钮*/}
                    <Button size="large" type="text" icon={<CopyFilled style={{ color: '#808080' }} />}
                        onClick={() => copyChatMessages(messages)} />
                    {/*语音播放*/}
                    <Button size="large" type="text" icon={<SoundFilled style={{ color: '#808080' }} />}
                        onClick={async () => {
                            const currentId = ++voiceRequestId.current; // 每次点击都生成新请求ID
                            setVoiceModalOpen(true);
                            try {
                                const audioURL = await generateVoice(message); // 获取并播放语音
                                // 如果此时用户已关闭 modal，或来了新的播放请求，就不再播放
                                if (voiceRequestId.current !== currentId) {
                                    console.log("🚫 播放请求已失效，取消播放");
                                    return;
                                }
                                setIsGotVoice(true);
                                const audio = new Audio(audioURL);
                                voiceAudio.current = audio;
                                await audio.play(); // ⚠️ 这一步是在“点击事件”中执行，不会被拦截！
                                // 监听播放完成事件，自动关闭 Modal
                                audio.onended = () => {
                                    if (audio) {
                                        audio.pause();
                                        audio.currentTime = 0;
                                    }
                                    setIsGotVoice(false);
                                    voiceAudio.current = null;
                                    setVoiceModalOpen(false);
                                };
                            } catch (e) {
                                messageApi.error("语音获取失败，请刷新页面重试");;
                            }
                        }} />
                    {/*赞*/}
                    <Button size="large" type="text"
                        icon={<LikeFilled style={{ color: feedBackCode === 1 ? '#FFA500' : '#C0C0C0' }} />}
                        disabled={feedBackCode === 2}
                        onClick={() => {
                            submitExcellentResponse(messages);
                            setFeedBackCode(1);
                        }} />
                    {/*BullShit*/}
                    <Button size="large" type="text"
                        icon={<DislikeFilled style={{ color: feedBackCode === 2 ? '#4682B4' : '#C0C0C0' }} />}
                        disabled={feedBackCode === 1}
                        onClick={() => {
                            setBullShitModalOpen(true);
                            setFeedBackCode(2);
                        }} />
                </Space>
            ) : null,
        }));
        setMessageItems(items);
    }, [messages, feedBackCode]);

    // 自动滚动到底部
    useLayoutEffect(() => {
        if (containerRef.current && willScroll) {
            // 延迟滚动操作，确保 DOM 渲染完成
            setTimeout(() => {
                containerRef.current.scrollTop = containerRef.current.scrollHeight;
            }, 1000); // 延迟1000毫秒
            // 滚动完成，设置为不需要滚动，防止在对话过程中无法操作与体验不好的现象
            setWillScroll(false)
        }
    }, [willScroll]);

    // 更新拓展问题
    useEffect(() => {
        const items = [
            {
                key: '6',
                icon: (<CoffeeOutlined style={{ color: '#964B00', }} />),
                description: questions[0] ? questions[0] : SUGGESTION_DEFAULT_VALUE_1,
                disabled: false,
            },
            {
                key: '7',
                icon: (<SmileOutlined style={{ color: '#FAAD14', }} />),
                description: questions[1] ? questions[1] : SUGGESTION_DEFAULT_VALUE_2,
                disabled: false,
            },
            {
                key: '8',
                icon: (<FireOutlined style={{ color: '#FF4D4F', }} />),
                description: questions[2] ? questions[2] : SUGGESTION_DEFAULT_VALUE_3,
                disabled: false,
            },
        ];
        setPrompts(items);
    }, [questions]);

    // 拓展问题点击事件
    const handlePromptItemClicked = (item) => {
        const query = item.data.description
        const sessionID = sessionStorage.getItem(ACTIVE_SESSION_KEY);
        if (sessionID === ACTIVE_SESSION_DEFAULT_VALUE) {
            message.error('未获取到相关会话信息').then();
            return;
        }
        // 本地化存储
        const messageItem = {
            id: 0,
            message: query,
            status: 'local',
        }
        addSessionMessages(sessionID, messageItem).then();
        onRequest(item.data.description);
        // 拓展三个问题
        getQuestions({ query: message }).then((questions) => {
            setSuggestions(questions);
            updateSessionSuggestions(sessionID, questions).then();
        });
    }

    // 语音弹出modal关闭的回调方法
    const voiceModalClosed = () => {
        // 增加请求ID，作废所有未完成的请求
        voiceRequestId.current += 1;
        if (voiceAudio.current) {
            voiceAudio.current.pause();
            voiceAudio.current.currentTime = 0;
        }
        voiceAudio.current = null;
        setIsGotVoice(false);
        setVoiceModalOpen(false);
    };

    return (
        <Row ref={containerRef} justify='center'
            style={{ height: '100%', overflow: "auto", scrollBehavior: 'smooth' }}>
            {contextHolder}
            <Col xs={22} sm={22} md={22} lg={15} xl={15}>
                <Space direction='vertical' size='large'>
                    <Bubble.List items={messageItems} roles={roles} />
                    <Bubble
                        variant="borderless"
                        avatar={{ icon: <UserOutlined />, style: { visibility: 'hidden' } }}
                        content={<Prompts items={prompts} onItemClick={handlePromptItemClicked} vertical />}
                    />
                </Space>
            </Col>
            <BullShitFeedBackModal open={bullShitModalOpen} setBullShitModalOpen={setBullShitModalOpen}
                messages={prevMessagesRef.current} />
            <VoiceModal open={voiceModalOpen} isMobile={isMobile} isGotVoice={isGotVoice} voiceModalClosed={voiceModalClosed} />
        </Row>
    );
};

export default ContentView;